import { Table } from '@components/Table'
import { NoData } from '@components/NoData'
import { Pagination } from '@components/Pagination'
import { PopupTableProps } from './interface'
import { columns } from './column'

export function PopupTable({
  data,
  isLoading,
  page,
  perpage,
  total,
  sort,
  pageChange,
  handleSort,
}: PopupTableProps) {
  return (
    <div>
      <Table
        data={data}
        columns={columns}
        isLoading={isLoading}
        onSort={handleSort}
        initialSort={{ key: sort.key, order: sort.order }}
      />
      <div className='mt-[30px]'>
        <Pagination
          page={page}
          perpage={perpage}
          total={total}
          pageChange={pageChange}
        />
      </div>
    </div>
  )
}
